import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SavePurchaseUseCase } from '../../core/domain/purchase-persistence/usecases/save-purchase-persistence.usecase';
import { PurchasePersistenceRepository } from '../../core/domain/purchase-persistence/repositories/purchase-persistence.repository';
import { PurchasePersistenceImplRepository } from './purchase-persistence-impl.repository';
import { DeletePurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/delete-purchase-persistence.usecase ';
import { GetPurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/get-purchase-persistence.usecase';

const savePurchasePersistenceUseCaseFactory = (
    purchasePersistenceRepository: PurchasePersistenceRepository,
) => new SavePurchaseUseCase(purchasePersistenceRepository);

const deletePurchasePersistenceUseCaseFactory = (
    purchasePersistenceRepository: PurchasePersistenceRepository,
) => new DeletePurchaseUseCase(purchasePersistenceRepository);

const getPurchasePersistenceUseCaseFactory = (
    purchasePersistenceRepository: PurchasePersistenceRepository,
) => new GetPurchaseUseCase(purchasePersistenceRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: SavePurchaseUseCase,
            useFactory: savePurchasePersistenceUseCaseFactory,
            deps: [PurchasePersistenceRepository],
        },
        {
            provide: DeletePurchaseUseCase,
            useFactory: deletePurchasePersistenceUseCaseFactory,
            deps: [PurchasePersistenceRepository],
        },
        {
            provide: GetPurchaseUseCase,
            useFactory: getPurchasePersistenceUseCaseFactory,
            deps: [PurchasePersistenceRepository],
        },
        {
            provide: PurchasePersistenceRepository,
            useClass: PurchasePersistenceImplRepository,
        },
    ],
})
export class PurchasePersistenceDataModule {}
